import { render, staticRenderFns } from "./UsuarioGrupoFornecedorList.vue?vue&type=template&id=25ffc362"
import script from "./UsuarioGrupoFornecedorList.vue?vue&type=script&lang=js"
export * from "./UsuarioGrupoFornecedorList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports